export default __webpack_public_path__ + "media/components/Video/Intro-99eab6f769f503e6b9697d7fe8a9a793.mp4";